import React from 'react'

export interface DataCardProps {
    title: string;
    data: string;

    status?: string;
    statusText?: string;
    statusStyle?: string;

    subdata?: string;
    onClick?: () => void;
    tutorialAnchor?: string;
}

export default function DataCard({ title, data, status, statusText, subdata, statusStyle = 'tag', onClick, tutorialAnchor }: DataCardProps) {
    return (
        <div
            data-tutorial={tutorialAnchor}
            className={`dashboard-card ${onClick ? 'cursor-pointer transition-colors hover:bg-gray-50' : ''}`}
            onClick={onClick}
            role={onClick ? 'button' : undefined}
            tabIndex={onClick ? 0 : undefined}
            onKeyDown={onClick ? (event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    onClick();
                }
            } : undefined}
        >
            <div className="dashboard-card-header !mb-2">{title}</div>
            <div className="font-semibold text-xl">{data}</div>

            {(statusText || subdata) &&
                <div className="flex items-center gap-3 mt-5">
                    {/* Tag Status */}
                    {(statusText && statusStyle === 'tag') &&
                        <div className={`tag-1 ${status === 'good' ? '!bg-green-100 !text-green-500'
                            : status === 'med' ? '!bg-yellow-100 !text-yellow-500'
                                : status === 'bad' ? '!bg-red-100 !text-red-500' : ''}`}>
                            {statusText}
                        </div>
                    }

                    {/* Dot Status */}
                    {(statusText && statusStyle === 'dot') &&
                        <div className="flex items-center gap-3">
                            <div className={`w-3 h-3 rounded-full ${status === 'good' ? 'bg-green-500'
                                : status === 'med' ? 'bg-yellow-500'
                                    : status === 'bad' ? 'bg-red-500' : 'bg-gray-500'}`}>
                            </div>
                            <div className="text-gray-500 text-sm font-medium">{statusText}</div>
                        </div>
                    }

                    {/* Subdata */}
                    {subdata &&
                        <div className="text-gray-500 text-sm font-medium">{subdata}</div>
                    }
                </div>
            }
        </div>
    )
}
